/* eslint-disable react/jsx-no-bind */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './emergency.css';
import { useNavigate } from 'react-router-dom';
import Nav from '../../components/Nav/Nav';
import Button from '../../components/Inputs/Button/Button';
import ColoredBar from '../../components/ColoredBar/ColoredBar';
import PageNames from '../../utils/PageNames';
import PageTypes from '../../utils/PageTypes';
import MetricsContext from '../../context/MetricsContext';
import GeoPermissionModal from '../../components/GeolocationModal';
import { getGeolocationPermissionState } from '../../utils';
import { PermissionsState } from '../../utils/common';

export default function Emergency() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { updateUserMetric, loading } = useContext(MetricsContext);
  const sessionId = localStorage.getItem('sessionId');
  const [showGeoModal, setShowGeoModal] = useState(false);
  const [geoPermissionState, setGeoPermissionState] = useState(PermissionsState.UNKNOWN);
  const startDate = useRef(new Date());
  const VERSION_STORAGE_KEY = '@kitoApp/version';
  const [, setActiveVersion] = useState(() => window.localStorage.getItem(VERSION_STORAGE_KEY) || 'Adult');

  useEffect(() => {
    updateUserMetric({
      name: PageNames.EMERGENCY_PAGE,
      pageType: PageTypes.DEFAULT,
    });
  }, [sessionId]);

  useEffect(() => {
    async function checkPermissions() {
      const permissionState = await getGeolocationPermissionState();
      setGeoPermissionState(permissionState);
      setShowGeoModal(permissionState === PermissionsState.DENIED);
    }
    checkPermissions().catch(() => {
      setGeoPermissionState(PermissionsState.UNKNOWN);
      setShowGeoModal(false);
    });
  }, []);

  function handleContinue() {
    const dateFinal = new Date();
    updateUserMetric({
      name: PageNames.EMERGENCY_PAGE,
      pageType: PageTypes.DEFAULT,
      duration: Math.abs(dateFinal - startDate.current),
      interactions: [
        {
          name: 'continue',
          time: dateFinal,
        },
      ],
    });
    if (!loading) {
      navigate('/ageGroup');
    }
  }

  function handleEmergencyClick() {
    const dateFinal = new Date();
    updateUserMetric({
      name: PageNames.EMERGENCY_PAGE,
      pageType: PageTypes.DEFAULT,
      duration: Math.abs(dateFinal - startDate.current),
      interactions: [
        {
          name: 'emergency',
          time: dateFinal,
        },
      ],
    });
  }

  return (
    <div className="container">
      <Nav backArrow logo closeButton sidebar onVersionChange={setActiveVersion} />
      <ColoredBar />
      <div className="containerContent emergency__page">
        <p>{t('emergencypage.p1')}</p>
        <br />
        <p>{t('emergencypage.p2')}</p>
        <br />
        <p>{t('emergencypage.p3')}</p>
        <ul>
          <li>
            <p>{t('emergencypage.li1')}</p>
          </li>
          <li>
            <p>{t('emergencypage.li2')}</p>
          </li>
          <li>
            <p>{t('emergencypage.li3')}</p>
          </li>
        </ul>
        <div className="emergency__bottomwrapper">
          <Button
            width="fullWidth"
            hierarchy="primary"
            disabled={loading}
            onClick={handleContinue}
            additionalClass=" agree"
          >
            {t('emergencypage.button1')}
          </Button>
          <a onClick={handleEmergencyClick} className="emergency__callBtn" href="tel:0800721316">
            {t('emergencypage.button2')}
          </a>
        </div>
      </div>
      {showGeoModal && (
        <GeoPermissionModal permissionState={geoPermissionState} onClose={() => setShowGeoModal(false)} />
      )}
    </div>
  );
}
